import * as dateUtils from '../../../utils/dateUtils';

import Form from '../Form';
import {captchaConstants} from '../../../components/global/Security/Captcha';


class CaptchaForm extends Form {

    /**
     * @return {Boolean} True if errors other than captcha exists
     */
    hasNonCaptchaErrors() {

        const allErrors = this.getErrors();
        const errorKeys = Object.keys(allErrors);
        const nonCaptchaErrorKeys = errorKeys.filter(key => !captchaConstants.CAPTCHA_FIELD_NAMES.includes(key));

        return nonCaptchaErrorKeys.length > 0;
    }


    /**
     * @returns {boolean} True if captcha is completed within the timeout duration
     */
    isCaptchaCompleted() {

        const validationTimeThreshold = dateUtils.now()
            .minus({
                day: captchaConstants.CAPTCHA_VALIDITY_MINUTES
            });
        const captchaCompletedAt = this.getData(captchaConstants.CAPTCHA_COMPLETED_AT_FIELD_NAME);

        return !this.getData(captchaConstants.CAPTCHA_IS_RUNNING_FIELD_NAME)
            && !!this.getData(captchaConstants.CAPTCHA_HAS_COMPLETED_FIELD_NAME)
            && !!this.getData(captchaConstants.CAPTCHA_SOLUTION_FIELD_NAME)
            && captchaCompletedAt
            && dateUtils.isAfter(validationTimeThreshold, captchaCompletedAt);
    }


    /**
     * @returns {boolean} True if captcha is running
     */
    isCaptchaRunning() {

        return !!this.getData(captchaConstants.CAPTCHA_IS_RUNNING_FIELD_NAME);
    }


    /**
     * @param solution {string} Captcha solution string
     */
    setCaptchaSolution(solution) {

        this.setData({
            [captchaConstants.CAPTCHA_COMPLETED_AT_FIELD_NAME]: dateUtils.now().toISO(),
            [captchaConstants.CAPTCHA_IS_RUNNING_FIELD_NAME]: false,
            [captchaConstants.CAPTCHA_HAS_COMPLETED_FIELD_NAME]: true,
            [captchaConstants.CAPTCHA_SOLUTION_FIELD_NAME]: solution
        });
    }


    /**
     * @param isCaptchaRunning {boolean} Indicator whether captcha is currently running
     */
    setIsCaptchaRunning(isCaptchaRunning = true) {

        if (isCaptchaRunning !== this.isCaptchaRunning()) {

            this.setData({
                [captchaConstants.CAPTCHA_IS_RUNNING_FIELD_NAME]: isCaptchaRunning
            });
        }
    }
}


export default CaptchaForm;
